module.exports = __webpack_public_path__ + "static/typography-1-704087f20c4b7cc0961d0dcd3802eb2e.png";